import { Box, Typography } from '@mui/material';

type SettingsEmptyStateProps = {
    message: string;
    imageSrc?: string;
    imageAlt?: string;
    minHeight?: number | string;
};

const SettingsEmptyState = ({
    message,
    imageSrc = '/images/no-exist.png',
    imageAlt = '',
    minHeight = 280,
}: SettingsEmptyStateProps) => (
    <Box
        sx={{
            minHeight,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            px: 2,
            py: { xs: 4, md: 5 },
        }}
    >
        <Box
            component="img"
            src={imageSrc}
            alt={imageAlt}
            sx={(theme) => ({
                width: 80,
                height: 80,
                objectFit: 'contain',
                mb: 2,
                filter:
                    theme.palette.mode === 'light'
                        ? 'brightness(0.4)'
                        : 'none',
            })}
        />
        <Typography
            className="font-yekan-heavy"
            sx={{ fontSize: 16, color: 'text.primary' }}
        >
            {message}
        </Typography>
    </Box>
);

export default SettingsEmptyState;
